export default __webpack_public_path__ + "static/website-0c262c226c9cde2a1a14dfe23bd1035d.jpg";